// mock t function for i18next scanner to pick up
const t = (x: string) => x

export enum AccountType {
    PersonAccount = 1,
    LedgerAccount,
    SupplierAccount,
    ProjectAccount,
    CostCenterAccount,
    CostObjectAccount,
    AnlageAccount,
    ContractAccount
}

export const AccountTypeLabels: {[k: string]: string} = {
    [AccountType.PersonAccount]: t('global:enum.AccountType.PersonAccount'),
    [AccountType.LedgerAccount]: t('global:enum.AccountType.LedgerAccount'),
    [AccountType.SupplierAccount]: t('global:enum.AccountType.SupplierAccount'),
    [AccountType.ProjectAccount]: t('global:enum.AccountType.ProjectAccount'),
    [AccountType.CostCenterAccount]: t('global:enum.AccountType.CostCenterAccount'),
    [AccountType.CostObjectAccount]: t('global:enum.AccountType.CostObjectAccount'),
    [AccountType.AnlageAccount]: t('global:enum.AccountType.AnlageAccount'),
    [AccountType.ContractAccount]: t('global:enum.AccountType.ContractAccount'),
}

export const accountTypeToOpts = (t: Function, settings: any) => {
    const opts = []

    for(let x in AccountType) {
        if (!isNaN(Number(x))) { continue }


        opts.push({
            name: t(AccountTypeLabels[AccountType[x as keyof typeof AccountType]]),
            value: AccountType[x as keyof typeof AccountType]
        })
    }

    return opts
}
